'use client';

import type { ReactNode } from 'react';
import { fetchHomepageProductsPageAtom } from '../../../../effect/atom/products/fetchHomepageProductsPage';
import type { ProductBase } from '../../../../effect/schema/openapi/backend';
import type { HydraCollectionResponseType } from '@vs-shop/schemas/openapi/response';
import * as AsyncResult from 'effect/unstable/reactivity/AsyncResult';
import { useAtomInitialValues } from '@effect/atom-react';

type Props = {
  taxonCode: string;
  page: number;
  itemsPerPage: number;
  productsResponse: HydraCollectionResponseType<typeof ProductBase>;
  children: ReactNode;
};

export default function HomepageProductsInitializer({
  taxonCode,
  page,
  itemsPerPage,
  productsResponse,
  children,
}: Props) {
  const atom = fetchHomepageProductsPageAtom(taxonCode, page, itemsPerPage);

  useAtomInitialValues([[atom, AsyncResult.success(productsResponse)]]);

  return children;
}
